import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from 'firebase/app-check';

export const FirebaseConfig = {
  apiKey: "AIzaSyCp950idaOkuz7AvAokV7inX2T7yQgSo0I",
  authDomain: "veezdelivery.firebaseapp.com",
  databaseURL: "https://veezdelivery-default-rtdb.firebaseio.com",
  projectId: "veezdelivery",
  storageBucket: "veezdelivery.firebasestorage.app",
  messagingSenderId: "821566645027",
  appId: "1:821566645027:web:7a4e301bc8aa0c4236e296",
  measurementId: "G-BDQ40PCC43",
  recaptchaSiteKey: "6LfADIktAAAAAIZ6rWqqOQs6ivZgFgVKtrotw4NW"
};

const app = getApps().length === 0 ? initializeApp(FirebaseConfig) : getApp();

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  try {
    if (process.env.NODE_ENV === 'development' && typeof self !== 'undefined') {
      const fixedDebugToken = 
        (typeof process !== 'undefined' && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) || 
        (typeof window !== 'undefined' && window.FIREBASE_APPCHECK_DEBUG_TOKEN) || 
        "d30e1d0f-6055-49c5-9dc0-b087d06a4459";

      self.FIREBASE_APPCHECK_DEBUG_TOKEN = fixedDebugToken;

      const customDebugProvider = new CustomProvider({
        getToken: () => {
          const projectId = app.options.projectId;
          const appId = app.options.appId;
          const apiKey = app.options.apiKey;
          const url = `https://firebaseappcheck.googleapis.com/v1/projects/${projectId}/apps/${appId}:exchangeDebugToken?key=${apiKey}`;

          return fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              debugToken: fixedDebugToken
            })
          })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              console.warn("App Check debug token exchange notice:", data.error.message);
              throw new Error(data.error.message || "Failed to exchange debug token");
            }
            const ttlSeconds = parseInt(data.ttl) || 3600;
            return {
              token: data.token,
              expireTimeMillis: Date.now() + ttlSeconds * 1000
            };
          });
        }
      });

      initializeAppCheck(app, {
        provider: customDebugProvider,
        isTokenAutoRefreshEnabled: true
      });
    } else {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(FirebaseConfig.recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true
      });
    }
  } catch (acErr) {
    console.warn("AppCheck web initialization notice:", acErr?.message || acErr);
  }
}

export const db = getFirestore(app, 'vzprod');
export const getFirestoreDb = () => db;
